import {
  GetQuestionCreationTaskByIdDocument,
  GetStepTransitionsByTaskIdDocument,
  useGetStepTransitionsByTaskIdQuery,
  useUpdateTaskStatusMutation,
} from '@exam-management/graphql';
import { useParams } from '@exam-management/router';
import { Button } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';

export default function StartTaskButton() {
  const { taskId } = useParams('/my-task/question-creation/:taskId');
  const { showSnackbar } = useSnackbar();

  const { data } = useGetStepTransitionsByTaskIdQuery({
    variables: {
      getStepTransitionsByTaskIdInput: {
        taskId,
      },
    },
  });

  const workflowStepId = data?.wflGetStepTransitionsByTaskId.steps?.[0]?.id ?? '';

  const [startTask, { loading: isLoading }] = useUpdateTaskStatusMutation({
    variables: {
      updateTaskStatusInput: {
        taskId,
        workflowStepId,
      },
    },
    refetchQueries: [
      {
        query: GetStepTransitionsByTaskIdDocument,
        variables: {
          getStepTransitionsByTaskIdInput: {
            taskId,
          },
        },
      },
      {
        query: GetQuestionCreationTaskByIdDocument,
        variables: {
          getTaskByIdInput: {
            taskId,
          },
        },
      },
    ],
  });

  const handleStartTaskClick = () => {
    if (!workflowStepId) {
      showSnackbar({
        message: 'Failed to start task',
        variant: 'error',
      });
      return;
    }

    startTask();
  };

  return (
    <Button size='large' onClick={handleStartTaskClick} loading={isLoading}>
      เริ่มสร้างคำถาม
    </Button>
  );
}
